<template>
  <a-card :bordered="false">
    <a-button type="primary" @click="openModel">新建关联</a-button>
    <custom-page-table
      ref="table"
      :queryParams="queryParams"
      style="margin-top:16px;"
      :columns="columns"
      :request-promise="getListPromise"
    >
      <span slot="status" slot-scope="rowItem">
        <span>{{ rowItem.record.status === 1 ? '启用' : '禁用' }}</span>
      </span>
      <span slot="action" slot-scope="rowItem">
        <a @click="editEvent(rowItem.record)">编辑</a>
        <a-divider type="vertical"/>
        <a v-if="rowItem.record.status===0" @click="onUpdateEvent(rowItem.record.id,1)">启用</a>
        <a v-else style="color:red;" @click="onUpdateEvent(rowItem.record.id,0)">禁用</a>
        <a-divider type="vertical"/>
        <a-popconfirm
          title="是否删除本条数据?"
          @confirm="deleteMember(rowItem.record.id)"
        >
    <a>删除</a>
  </a-popconfirm>
      </span>
    </custom-page-table>
    <a-modal :title="memberId?'编辑关联':'新建关联'"
             width="800px"
             :visible="visible"
             @ok="handleSubmit"
             @cancel="visible = false"
    >
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="用户名（UserID）" prop="supplierUserId">
          <a-input style="width: 400px;" v-model="ruleForm.supplierUserId" :maxLength="50"
                   placeholder="请输入"></a-input>
        </a-form-model-item>
        <a-form-model-item label="密码（PassWord）" prop="supplierPassword">
          <a-input style="width: 400px;" v-model="ruleForm.supplierPassword" :maxLength="50"
                   placeholder="请输入"></a-input>
        </a-form-model-item>
        <a-form-model-item label="选择关联分销员" prop="statffList">
          <a-button type="primary" @click="onStaffVisible()">选择</a-button>
          <div>
            <template v-for="tagItem in ruleForm.statffList">
              <a-tag closable color="blue" @close="handleStaffClose(tagItem.staffId)" :key="tagItem.staffId">
                {{ tagItem.staffName }}
              </a-tag>
            </template>
          </div>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal title="选择分销员" :footer="null" :width="650" :visible="staffVisible"
             @cancel="staffChange">
      <div>
        <a-form layout="inline">
          <a-form-item label="搜索名称">
            <a-input v-model="queryStaff.staffSearchInfo" placeholder="搜索手机号、真实姓名"></a-input>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="$refs.tableStaff.refresh(true)">查询</a-button>
          </a-form-item>
        </a-form>
      </div>
      <custom-page-table
        ref="tableStaff"
        :queryParams="queryStaff"
        :columns="columnsStaff"
        :request-promise="getStaffListPromise"
      >
          <span slot="action" slot-scope="rowItem">
            <a-button type="primary" size="small" @click="selectStaffId(rowItem.record)">添加</a-button>
          </span>
      </custom-page-table>
    </a-modal>
  </a-card>
</template>

<script>
export default {
  name: 'DistributionMember',
  data() {
    return {
      queryParams: {},
      columns: [
        {
          title: '用户名（UserID）',
          dataIndex: 'supplierUserId'
        },
        {
          title: '关联分销员',
          dataIndex: 'staffName'
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          width: '220px',
          fixed: 'right'
        }
      ],
      columnsStaff: [
        {
          title: 'ID',
          dataIndex: 'staffId'
        },
        {
          title: '姓名',
          dataIndex: 'staffName'
        },
        {
          title: '手机号',
          dataIndex: 'staffMobile'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      memberId: '',
      visible: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      ruleForm: {
        statffList: [],
        supplierUserId: '',
        supplierPassword: ''
      },
      rules: {
        statffList: [{ required: true, message: '请选择关联分销员', trigger: ['blur', 'change'] }],
        supplierUserId: [{ required: true, message: '请输入用户名（UserID）', trigger: ['blur', 'change'] }],
        supplierPassword: [{ required: true, message: '密码（PassWord）', trigger: ['blur', 'change'] }]
      },
      staffVisible: false,
      queryStaff: {
        staffSearchInfo: ''
      },
      accountId: this.$route.query.accountId
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'SynchronousProducts', title: '同步产品' },
      { name: 'DirectOrdersList', title: '订单直连' },
      { name: 'TogetherAccount', title: '关联账号' }
    ])
  },
  methods: {
    deleteMember(id) {
      this.getHttpServices()
        .getServerApiService()
        .get('travel/staff/delete/' + id)
        .then(res => {
          this.$message.success('删除成功')
          this.$refs.table.refresh(true)
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    staffChange() {
      this.staffVisible = false
    },
    onStaffVisible() {
      this.staffVisible = true
    },
    handleStaffClose(removedTag) {
      if (this.ruleForm.statffList.length > 0) {
        const tags = this.ruleForm.statffList.filter(tag => tag.staffId !== removedTag)
        this.ruleForm.statffList = tags
      }
    },
    selectStaffId(obj) {
      if (this.ruleForm.statffList.length > 0) {
        let flag = false
        this.ruleForm.statffList.map(item => {
          if (item.staffId == obj.staffId) {
            this.$message.error('请勿重复添加分销员')
            flag = true
          }
        })
        if (!flag) {
          this.ruleForm.statffList.push({
            staffId: obj.staffId,
            staffName: obj.staffName
          })
          this.staffVisible = false
        }
      } else {
        this.ruleForm.statffList.push({
          staffId: obj.staffId,
          staffName: obj.staffName
        })
        this.staffVisible = false
      }
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitEvent()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    submitEvent() {
      let params = {
        merchantId: this.merchantId,
        platformId: this.platformId,
        supplierPassword: this.ruleForm.supplierPassword,
        supplierUserId: this.ruleForm.supplierUserId,
        accountId: this.accountId,
        id: this.memberId ? this.memberId : 0,
        statffList: this.ruleForm.statffList
      }
      let msg = this.memberId ? '编辑成功' : '成功添加'
      this.getHttpServices().getServerApiService().post('travel/update/staff', params)
        .then(res => {
          this.$message.success(msg)
          this.visible = false
          this.$refs.table.refresh(true)
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    openModel() {
      this.memberId = ''
      this.ruleForm = {
        statffList: []
      }
      this.visible = true
    },
    getDetails() {
      if (this.memberId) {
        this.getHttpServices().getServerApiService().get('travel/query/' + this.memberId)
          .then(res => {
            this.ruleForm = {
              supplierUserId: res.supplierUserId,
              supplierPassword: res.supplierPassword,
              statffList: res.statffList && res.statffList.length > 0 ? res.statffList : []
            }
          }).catch(reason => {
          this.showNetWorkErrorMessage(reason)
        })
      }
    },
    onUpdateEvent(id, type) {
      let params = {
        merchantId: this.merchantId,
        platformId: this.platformId,
        id: id,
        status: type
      }
      this.getHttpServices().getServerApiService().post('travel/update/staff/status', params)
        .then(res => {
          this.showVisible = false
          this.$refs.table.refresh(true)
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    getListPromise(params) {
      let param = {
        ...params,
        merchantId: this.merchantId,
        platformId: this.platformId,
        accountId: this.accountId
      }
      return this.getHttpServices().getServerApiService().post('travel/staff/supplier/all', param)
    },
    getStaffListPromise(params) {
      return this.getHttpServices().getUserService().post('staff/v2/getProviderStaffList', params)
    },
    editEvent(record) {
      this.memberId = record.id
      this.getDetails()
      this.visible = true
    }
  }
}
</script>

<style scoped>

</style>